export default __webpack_public_path__ + "static/media/feature-item-event.38f9e707.svg";